import type { AttachmentFileList } from 'owa-attachment-file-types';
import { lazyLogAttachOrShareDatapoint } from 'owa-attachment-filepicker';
import type { CreateAttachmentsProperties } from 'owa-attachment-well-data';
import { lazyInsertLinks } from 'owa-insert-link';
import getCurrentFromAddress from 'owa-mail-compose-actions/lib/utils/getFromAddressFromRecipientWell';
import type { ComposeViewState } from 'owa-mail-compose-store';
import type AttachmentDataProviderType from 'owa-service/lib/contract/AttachmentDataProviderType';
import { getInsertLinksHost } from './getInsertLinksHost';

export async function upsellAndInsertLinks(
    files: AttachmentFileList,
    viewState: ComposeViewState,
    properties: CreateAttachmentsProperties,
    dataProvider: AttachmentDataProviderType,
    targetWindow: Window
): Promise<void> {
    const logAttachOrShareDatapoint = await lazyLogAttachOrShareDatapoint.import();
    logAttachOrShareDatapoint({
        files: files,
        isInline: false,
        shouldShare: true,
        dataProviderType: dataProvider,
    });
    const insertLinks = await lazyInsertLinks.import();
    insertLinks(
        files,
        getInsertLinksHost(viewState),
        viewState,
        getCurrentFromAddress(viewState.toRecipientWell),
        targetWindow,
        viewState.linksContainerId,
        null /* selectionText*/,
        properties
    );
}
